import { InertiaLink, InertiaLinkProps } from '@inertiajs/inertia-react'
import React from 'react'

export interface LinkProps extends InertiaLinkProps {
    defaultColor?: boolean
    defaultPadding?: boolean
    defaultFocus?: boolean
}

function Button(props: LinkProps) {
    const {className, defaultColor = true, defaultPadding = true, defaultFocus = true, ...rest} = props

    let isPathAbsolute = (path: string) => {
        return (path.includes("https://") || path.includes("http://"));
    }

    function is_external(href) {
        try {
            return (href && (isPathAbsolute(href) && !href.includes(window?.location.host)))         
        } catch (error) {
            return false;
        }

    }

    let Tag = is_external(props.href) ? 'a' : InertiaLink

    return (
        <Tag className={`h-48px ${defaultColor && "text-white bg-green-539648"} rounded-md ${defaultPadding && "px-22px"} inline-flex items-center ${defaultFocus && "focus:outline-none"} justify-center text-14 font-bold ${className} hover:bg-green-700 hover:text-white`} target={is_external(props.href) ? '_blank' : undefined} {...rest} />
    )
}

export default Button
